// // import css from "./hero.module.css";
// // import { HandySvg } from "handy-svg";
// // import iconSrc from "../../svg/smallProductLike.svg";
// // import iconSrcCard from "../../svg/smallProductCard.svg";
// // import addToCart from "../../function/addToCard";
// // import { useState, useEffect } from "react";
// // import { Link } from "react-router-dom";
// // import transliterate from "../../function/transliterate";
// // import { PhotoProvider, PhotoView } from "react-photo-view";
// // import { getProductHref } from "../../function/productLink";
// // export default function ProductForHero({ el }) {
// //   const [liked, setLiked] = useState(false);

// //   useEffect(() => {
// //     // Отримуємо дані з localStorage
// //     const likedProducts =
// //       JSON.parse(localStorage.getItem("likedProducts")) || [];

// //     // Перевіряємо, чи товар є в масиві вподобаних
// //     const isLiked = likedProducts.some((product) => product.uid === el.uid);

// //     // Встановлюємо відповідний стан liked
// //     setLiked(isLiked);
// //   }, []);

// //   const handleLike = () => {
// //     let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];

// //     if (!liked) {
// //       likedProducts.push(el);
// //     } else {
// //       likedProducts = likedProducts.filter((product) => product.uid !== el.uid);
// //     }

// //     localStorage.setItem("likedProducts", JSON.stringify(likedProducts));

// //     setLiked(!liked);
// //   };

// //   return (
// //     <div className={css.smallProductWrap}>
// //       {/* Слайдер фото */}
// //       <PhotoProvider>
// //         <PhotoView src={el.imageList[0]}>
// //           <img
// //             src={el.imageList[0]}
// //             className={css.productPicSmall}
// //             alt={el.bookName}
// //           />
// //         </PhotoView>
// //         {el.imageList.slice(1).map((img, index) => (
// //           <PhotoView key={index} src={img}>
// //             <span style={{ display: "none" }} />
// //           </PhotoView>
// //         ))}
// //       </PhotoProvider>

// //       <div className={css.prodPricLikeCart}>
// //         <div className={css.prdeProdPricingCart}>
// //           <div className={css.prdeProdPricingRotateCart}>
// //             <p className={css.salePriceCart}>{el.price}</p>
// //             <p className={css.fullPriceCart}>грн</p>
// //           </div>
// //         </div>
// //         <div className={css.likeCardWrapSmall}>
// //           <div
// //             className={`${css.likeProductSmall} ${
// //               liked ? css.likeProductSmallClick : ""
// //             }`}
// //             onClick={handleLike}
// //           >
// //             <HandySvg src={iconSrc} width="34" height="31" />
// //           </div>
// //           <div
// //             className={css.likeProductSmall}
// //             onClick={() => addToCart(el.uid)}
// //           >
// //             <HandySvg src={iconSrcCard} width="28.33" height="28.33" />
// //           </div>
// //         </div>
// //       </div>

// //       {/* Посилання на сторінку товару */}
// //       <h2 className={css.smallProdName}>
// //         <Link to={getProductHref(el)} className={css.smallProdName}>
// //           {el.bookName}
// //         </Link>
// //       </h2>

// //       <div className={css.autorInformCart}>
// //         <div className={css.autorInformSectionCart}>
// //           <p className={css.pLikeP}>Автор:&nbsp;</p>
// //           <h4 className={css.h4LikeP}>{el.textAutor}</h4>
// //         </div>
// //         <div className={css.autorInformSectionCart}>
// //           <p className={css.pLikeP}>Художник:&nbsp;</p>
// //           <h4 className={css.h4LikeP}>{el.picWriter}</h4>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// import css from "./hero.module.css";
// import { HandySvg } from "handy-svg";
// import iconSrc from "../../svg/smallProductLike.svg";
// import iconSrcCard from "../../svg/smallProductCard.svg";
// import addToCart from "../../function/addToCard";
// import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import transliterate from "../../function/transliterate";
// import { PhotoProvider, PhotoView } from "react-photo-view";
// import { getProductHref } from "../../function/productLink";
// import { isProductVisible } from "../../function/productVisibility";
// export default function ProductForHero({ el }) {
//   const [liked, setLiked] = useState(false);

//   useEffect(() => {
//     // Отримуємо дані з localStorage
//     const likedProducts =
//       JSON.parse(localStorage.getItem("likedProducts")) || [];

//     // Перевіряємо, чи товар є в масиві вподобаних
//     const isLiked = likedProducts.some((product) => product.uid === el.uid);

//     // Встановлюємо відповідний стан liked
//     setLiked(isLiked);
//   }, []);

//   const handleLike = () => {
//     let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];

//     if (!liked) {
//       likedProducts.push(el);
//     } else {
//       likedProducts = likedProducts.filter((product) => product.uid !== el.uid);
//     }

//     localStorage.setItem("likedProducts", JSON.stringify(likedProducts));

//     setLiked(!liked);
//   };
//   const getPriceInfo = (product) => {
//     if (product?.priceSale && product.priceSale !== "") {
//       return {
//         hasDiscount: true,
//         oldPrice: product.priceSale,
//         currentPrice: product.price,
//       };
//     }

//     if (product?.salePrice) {
//       return {
//         hasDiscount: true,
//         oldPrice: product.price,
//         currentPrice: product.salePrice,
//       };
//     }

//     if (product?.actionPrice) {
//       return {
//         hasDiscount: true,
//         oldPrice: product.price,
//         currentPrice: product.actionPrice,
//       };
//     }

//     return {
//       hasDiscount: false,
//       oldPrice: null,
//       currentPrice: product?.price,
//     };
//   };

//   const priceInfo = getPriceInfo(el);
//   return (
//     <div className={css.smallProductWrap}>
//       {/* Слайдер фото */}
//       <PhotoProvider>
//         <PhotoView src={el.imageList[0]}>
//           <img
//             src={el.imageList[0]}
//             className={css.productPicSmall}
//             alt={el.bookName}
//           />
//         </PhotoView>
//         {el.imageList.slice(1).map((img, index) => (
//           <PhotoView key={index} src={img}>
//             <span style={{ display: "none" }} />
//           </PhotoView>
//         ))}
//       </PhotoProvider>

//       <div className={css.prodPricLikeCart}>
//         <div
//           className={`${css.prdeProdPricingCart} ${
//             priceInfo.hasDiscount ? css.prdeProdPricingCartDiscount : ""
//           }`}
//         >
//           <div className={css.prdeProdPricingRotateCart}>
//             {priceInfo.hasDiscount && (
//               <p className={css.oldPriceCart}>{priceInfo.oldPrice}</p>
//             )}

//             <p
//               className={
//                 priceInfo.hasDiscount
//                   ? css.salePriceCartDiscount
//                   : css.salePriceCart
//               }
//             >
//               {priceInfo.currentPrice}
//             </p>

//             <p
//               className={
//                 priceInfo.hasDiscount
//                   ? css.fullPriceCartDiscount
//                   : css.fullPriceCart
//               }
//             >
//               грн
//             </p>
//           </div>
//         </div>
//         <div className={css.likeCardWrapSmall}>
//           <div
//             className={`${css.likeProductSmall} ${
//               liked ? css.likeProductSmallClick : ""
//             }`}
//             onClick={handleLike}
//           >
//             <HandySvg src={iconSrc} width="34" height="31" />
//           </div>
//           <div
//             className={css.likeProductSmall}
//             onClick={() => addToCart(el.uid)}
//           >
//             <HandySvg src={iconSrcCard} width="28.33" height="28.33" />
//           </div>
//         </div>
//       </div>

//       {/* Посилання на сторінку товару */}
//       <h2 className={css.smallProdName}>
//         <Link to={getProductHref(el)} className={css.smallProdName}>
//           {el.bookName}
//         </Link>
//       </h2>

//       <div className={css.autorInformCart}>
//         <div className={css.autorInformSectionCart}>
//           <p className={css.pLikeP}>Автор:&nbsp;</p>
//           <h4 className={css.h4LikeP}>{el.textAutor}</h4>
//         </div>
//         <div className={css.autorInformSectionCart}>
//           <p className={css.pLikeP}>Художник:&nbsp;</p>
//           <h4 className={css.h4LikeP}>{el.picWriter}</h4>
//         </div>
//       </div>
//     </div>
//   );
// }
import css from "./hero.module.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../svg/smallProductLike.svg";
import iconSrcCard from "../../svg/smallProductCard.svg";
import addToCart from "../../function/addToCard";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { getProductHref } from "../../function/productLink";
import { isProductVisible } from "../../function/productVisibility";

export default function ProductForHero({ el }) {
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    if (!el?.uid) {
      setLiked(false);
      return;
    }

    try {
      const likedProducts =
        JSON.parse(localStorage.getItem("likedProducts")) || [];

      const isLiked = Array.isArray(likedProducts)
        ? likedProducts.some((product) => product?.uid === el.uid)
        : false;

      setLiked(isLiked);
    } catch (error) {
      console.error("Помилка отримання бажаних товарів:", error);
      setLiked(false);
    }
  }, [el?.uid]);

  const handleLike = () => {
    if (!el?.uid || !isProductVisible(el)) return;

    try {
      let likedProducts =
        JSON.parse(localStorage.getItem("likedProducts")) || [];

      if (!Array.isArray(likedProducts)) {
        likedProducts = [];
      }

      if (!liked) {
        const withoutDuplicate = likedProducts.filter(
          (product) => product?.uid !== el.uid,
        );

        likedProducts = [...withoutDuplicate, el];
      } else {
        likedProducts = likedProducts.filter(
          (product) => product?.uid !== el.uid,
        );
      }

      localStorage.setItem("likedProducts", JSON.stringify(likedProducts));

      setLiked((previousValue) => !previousValue);
    } catch (error) {
      console.error("Помилка оновлення бажаних товарів:", error);
    }
  };

  const getPriceInfo = (product) => {
    if (product?.priceSale && product.priceSale !== "") {
      return {
        hasDiscount: true,
        oldPrice: product.priceSale,
        currentPrice: product.price,
      };
    }

    if (product?.salePrice) {
      return {
        hasDiscount: true,
        oldPrice: product.price,
        currentPrice: product.salePrice,
      };
    }

    if (product?.actionPrice) {
      return {
        hasDiscount: true,
        oldPrice: product.price,
        currentPrice: product.actionPrice,
      };
    }

    return {
      hasDiscount: false,
      oldPrice: null,
      currentPrice: product?.price,
    };
  };

  // Страховка: прихований товар взагалі не рендеримо
  if (!isProductVisible(el)) {
    return null;
  }

  const imageList = Array.isArray(el?.imageList)
    ? el.imageList.filter(Boolean)
    : [];

  const mainImage = imageList[0] || "";

  const priceInfo = getPriceInfo(el);

  return (
    <div className={css.smallProductWrap}>
      {mainImage && (
        <PhotoProvider>
          <PhotoView src={mainImage}>
            <img
              src={mainImage}
              className={css.productPicSmall}
              alt={el.bookName || "Книга"}
            />
          </PhotoView>

          {imageList.slice(1).map((img, index) => (
            <PhotoView key={`${img}-${index}`} src={img}>
              <span style={{ display: "none" }} />
            </PhotoView>
          ))}
        </PhotoProvider>
      )}

      <div className={css.prodPricLikeCart}>
        <div
          className={`${css.prdeProdPricingCart} ${
            priceInfo.hasDiscount ? css.prdeProdPricingCartDiscount : ""
          }`}
        >
          <div className={css.prdeProdPricingRotateCart}>
            {priceInfo.hasDiscount && (
              <p className={css.oldPriceCart}>{priceInfo.oldPrice}</p>
            )}

            <p
              className={
                priceInfo.hasDiscount
                  ? css.salePriceCartDiscount
                  : css.salePriceCart
              }
            >
              {priceInfo.currentPrice}
            </p>

            <p
              className={
                priceInfo.hasDiscount
                  ? css.fullPriceCartDiscount
                  : css.fullPriceCart
              }
            >
              грн
            </p>
          </div>
        </div>

        <div className={css.likeCardWrapSmall}>
          <div
            className={`${css.likeProductSmall} ${
              liked ? css.likeProductSmallClick : ""
            }`}
            onClick={handleLike}
          >
            <HandySvg src={iconSrc} width="34" height="31" />
          </div>

          <div
            className={css.likeProductSmall}
            onClick={() => {
              if (!isProductVisible(el)) return;
              addToCart(el.uid);
            }}
          >
            <HandySvg src={iconSrcCard} width="28.33" height="28.33" />
          </div>
        </div>
      </div>

      <h2 className={css.smallProdName}>
        <Link to={getProductHref(el)} className={css.smallProdName}>
          {el.bookName}
        </Link>
      </h2>

      <div className={css.autorInformCart}>
        <div className={css.autorInformSectionCart}>
          <p className={css.pLikeP}>Автор:&nbsp;</p>
          <h4 className={css.h4LikeP}>
            {Array.isArray(el.textAutor)
              ? el.textAutor.join(", ")
              : el.textAutor}
          </h4>
        </div>

        <div className={css.autorInformSectionCart}>
          <p className={css.pLikeP}>Художник:&nbsp;</p>
          <h4 className={css.h4LikeP}>
            {Array.isArray(el.picWriter)
              ? el.picWriter.join(", ")
              : el.picWriter}
          </h4>
        </div>
      </div>
    </div>
  );
}
